import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import * as moment from 'moment';
import {MatDialog} from '@angular/material/dialog';
import {NotationService} from '../../../shared/services/notation/notation.service';
import {switchMap} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {ProjectService} from '../../../shared/services/project/project.service';
import {NotationsModalComponent} from './notations-modal/notations-modal.component';
import {IconService} from '../../../shared/services/icon/icon.service';
import {AbstractMatTable} from '../../../shared/classes/mat-table/abstract-mat-table';
import {Observable, Subscription} from 'rxjs';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';

@Component({
  selector: 'app-project-notations',
  templateUrl: './project-notations.component.html',
  styleUrls: ['./project-notations.component.scss']
})
export class ProjectNotationsComponent extends AbstractMatTable implements OnInit {

  project: any;
  isLoading: boolean = true;
  isBlurred: boolean = true;

  get selectedProjectId() {
    return (<any>this.route.params).value.idProject;
  }

  innerHeight: number = window.innerHeight;

  constructor(private projectService: ProjectService,
              private route: ActivatedRoute,
              private matDialog: MatDialog,
              private notationService: NotationService,
              private translateService: TranslateService,
              private toastr: ToastrService,
              public iconService: IconService) {
    super();

  }

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    this.initComponent();
  }

  initComponent() {
    this.showSpinner = true;
    this.projectService.getProject(this.selectedProjectId, 'notations,locations')
      .subscribe(
        (project: any) => {
          this.project = project;
          this.setMatTable(this.projectService.getProjectNoteUser(this.selectedProjectId, 'notations,locations'),
            ['noted_at', 'noted_changed_at', 'noted_updated_at', 'note_litteral', 'note_justification', 'note_user_name', 'note_action']);
        },
        () => {

        }
      );
  }

  formatDate(date: string, setLocalTime: boolean = false) {
    if (!date) {
      return undefined;
    }
    return moment(date).utc(setLocalTime).format('DD/MM/YYYY HH:mm');
  }

  openNotationModal(noteId = undefined, notedAt: string = undefined, justification: string = undefined, action: 'read' = undefined) {
    setTimeout(
      () => this.isBlurred = true, 500
    );
    this.matDialog.open(NotationsModalComponent, {
      height: (this.innerHeight * 0.7).toString() + 'px',
      width: '1000px',
      data: {
        projectId: this.selectedProjectId,
        project: this.project,
        noteId: noteId,
        action: action,
        notedAt: notedAt,
        justification: justification,
        aboMath: this.project.project_status_abo_maths && this.project.project_status_abo_maths.state > 0
      }
    })
      .afterClosed()
      .subscribe(
        (result) => {
          if (result === 'success' && action !== 'read') {
            this.showSpinner = true;
            this.initComponent();
          } else {
            this.showSpinner = false;
          }
        }
      );
  }

  deleteNote(noteId) {
    this.showSpinner = true;
    this.translateService.get('NOTES_DELETE_CONFIRM').subscribe(
      (translation) => {
        if (window.confirm(`${translation}`)) {
          this.notationService.deleteNote(noteId)
            .pipe(
              switchMap(
                () => this.translateService.get('NOTES_DELETE_SUCCESS')
              )
            )
            .subscribe(
              (message) => {
                this.toastr.success(message);
                this.initComponent();
              }
            );
        } else {
          this.showSpinner = false;
        }
      }
    );
  }


}
